import uuidv4 from 'uuid/v4'

export const randomUuid = () => {
    return uuidv4()
}

export const parseUrl = (url) => {
    if (url?.startsWith('/')) {
        return `${process.env.VUE_APP_API_URL}${url}`
    }
    return url
}
